<template>
  <div>
    <b-form-select
      :options="options"
      :value="value"
      @input="updateValue"
    ></b-form-select>
  </div>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'Select',

  props: {
    data: {
      type: Object
    },

    value: {
      type: [Number, String],
      default () {
        return get(this.data, 'default', null)
      }
    }
  },

  computed: {
    options () {
      let options = this.data.options

      if (get(this.data, 'allowEmpty') !== false) {
        options.unshift({
          value: null,
          text: get(this.data, 'emptyOption') || 'All'
        })
      }

      return options
    }
  },

  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>